import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';

@Injectable({
  providedIn: 'root'
})
export class AdvertisementService {
  host = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getAdvertisement(Authorization?: string, page?: number, size?: number, body?: any): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (Authorization) {
      params = params.append('Authorization', Authorization)
    }
    if (page) {
      params = params.append('page', page?.toString() || '0')
    }
    if (size) {
      params = params.append('size', size?.toString() || '10');
    }
    return this.http.post<CustomHttpResponse>(`${this.host}/v1/public/advertisements/available/get`, body, {
      observe: 'response',
      params
    })
  }

  addReaction(Authorization?: string, body?: any): Observable<HttpResponse<CustomHttpResponse>> {
    let params = new HttpParams();
    if (Authorization && Authorization.trim() !== '') {
      params = params.append('Authorization', Authorization);
    }
    return this.http.post<CustomHttpResponse>(`${this.host}/v1/public/advertisements/reaction`, body,
      {observe: 'response', params})

  }
}
